module.exports = __webpack_public_path__ + "img/btn-ticket.d4759641.svg";